import { render, staticRenderFns } from "./proList.vue?vue&type=template&id=c5b58c08&"
import script from "./proList.vue?vue&type=script&lang=js&"
export * from "./proList.vue?vue&type=script&lang=js&"
import style0 from "./proList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports